import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { ItemSearch } from "@/components/wh/ItemSearch";
import { WhSwitch } from "@/components/wh/WhSwitch";
import { useWh } from "@/lib/wh";

export default function WhSearch() {
  const [params] = useSearchParams();
  const [lots, setLots] = useState([]);
  const { wh } = useWh();
  useEffect(() => { api.get("/wh/lots", { params: { wh } }).then(({ data }) => setLots(data)).catch(() => {}); }, [wh]);
  const noLot = params.get("lot") === "none";
  return (
    <div className="space-y-6">
      <Link to="/magazzino" className="text-sm text-[var(--muted)] flex items-center gap-1" data-testid="wh-back"><ArrowLeft className="h-4 w-4" /> Magazzino</Link>
      <div className="fade-up"><p className="eyebrow">Tutti i lotti</p><h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">{noLot ? "Da smistare (senza lotto)" : "Ricerca globale"}</h1>
        <p className="text-sm text-[var(--muted)] mt-1">Con un lettore barcode USB o Bluetooth: clicca nella barra e scansiona, la scheda si apre da sola.</p></div>
      <WhSwitch />
      <ItemSearch key={wh} lots={lots} lotId={noLot ? "none" : ""} title={noLot ? "articoli senza lotto" : "ricerca"} />
    </div>
  );
}
